import { translateInline } from '@/globals/translate/translateInline';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { textBlock, textStyle } from '@/uiPrimitives/typography/text';

export const FieldLabel = ({
	id,
	htmlFor,
	label,
	required,
}: {
	id?: string;
	htmlFor: string | undefined; // can explicitely be undefined for radios
	label: string;
	required: boolean;
}) => {
	return (
		<label id={id} htmlFor={htmlFor} className={classes(textBlock({}))}>
			{label}
			{!required && (
				<span
					className={classes(textStyle({ color: 'positiveMuted' }))}
				>{` (${translateInline({
					en: 'optional',
					nl: 'optioneel',
				})})`}</span>
			)}
		</label>
	);
};
